(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fall-local-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = () => {
    document.querySelectorAll('[data-fall-campaign]').forEach(section => {
      if (section.dataset.fallReady) return;
      section.dataset.fallReady = 'true';
      const focus = section.dataset.fallCampaign;
      const pendingKey = 'gg-fall-pending-' + focus;
      const sync = () => {
        const idField = section.querySelector('[data-fall-lead-id]');
        if (idField && !idField.value) idField.setAttribute('value', Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12));
        const privacy = window.Shopify?.customerPrivacy;
        const allowed = privacy?.analyticsProcessingAllowed() && privacy?.marketingAllowed();
        const params = new URLSearchParams(window.location.search);
        section.querySelectorAll('[data-fall-attribution]').forEach(field => {
          field.setAttribute('value', allowed ? (params.get(field.dataset.fallAttribution) || '').replace(/[<>\r\n]/g, '').slice(0, 200) : '');
        });
        if (!allowed || !section.querySelector('[data-fall-inquiry-success]')) return;
        try {
          const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
          if (!pending || Date.now() - pending.time > 86400000) return;
          sessionStorage.removeItem(pendingKey);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({event: 'gg_fall_inquiry', lead_id: pending.id, inquiry_type: focus === 'x' ? 'xlab' : 'service'});
          const sendEvent = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
          sendEvent('event', 'conversion', {send_to: 'AW-11207037015/Zty4CPGegfocENeg998p', transaction_id: pending.id, value: 0, currency: 'USD'});
        } catch (error) { return; }
      };
      section.addEventListener('click', event => {
        const link = event.target.closest('[data-fall-model]');
        if (!link) return;
        const interest = section.querySelector('select[name="contact[Interest]"]');
        if (interest) { interest.value = link.dataset.fallModel; interest.dispatchEvent(new Event('change', {bubbles: true})); }
      });
      section.addEventListener('focusin', sync);
      section.addEventListener('submit', () => {
        sync();
        const idField = section.querySelector('[data-fall-lead-id]');
        const privacy = window.Shopify?.customerPrivacy;
        if (!idField?.value || !privacy?.analyticsProcessingAllowed() || !privacy?.marketingAllowed()) return;
        try { sessionStorage.setItem(pendingKey, JSON.stringify({id: idField.value, time: Date.now()})); } catch (error) { return; }
      });
      sync();
      document.addEventListener('visitorConsentCollected', sync);
      if (window.Shopify?.customerPrivacy) sync();
      else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) sync(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const text = JSON.parse(root.querySelector('.gg-translations').textContent);
    Object.keys(text).forEach(key => { text[key] = text[key].replaceAll('&amp;', '&'); });
    const form = root.querySelector('.gg-search'), input = form.querySelector('[name=q]');
    const wrap = root.querySelector('.gg-results-wrap'), results = root.querySelector('.gg-results');
    const status = root.querySelector('.gg-result-status'), more = root.querySelector('[data-more]');
    let intent = 'ship', page = 1, current = '', controller, generation = 0;
    try { intent = sessionStorage.getItem('gograva-shopping-intent') === 'local' ? 'local' : 'ship'; } catch {}
    const restrictedBrand = p => /giant|tern/i.test(p.vendor || '') || /\b(giant|tern)\b/i.test(p.title || '');
    const knownAccessory = p => /^(bicycle accessories|bike accessories|accessories|bicycle parts|bike parts|components|apparel|helmets|gloves|tires|tubes|pedals|grips|bottles|lights|bicycle bag|bicycle tube|bicycle pump|bicycle grips|pedal)$/i.test((p.product_type || '').trim());
    const localOnly = p => p.local_only === true || (restrictedBrand(p) && !knownAccessory(p));
    const isService = p => p.service === true || p.requires_shipping === false || /^(service|services|service package)$/i.test((p.product_type || '').trim());
    function setIntent(value) {
      intent = value;
      try { sessionStorage.setItem('gograva-shopping-intent', intent); } catch {}
      root.querySelectorAll('.gg-intents input').forEach(r => { r.checked = r.value === intent; });
      root.querySelector('[data-intent-copy]').textContent = intent === 'ship' ? text.ship_intro : text.local_intro;
      root.querySelectorAll('[data-local-only]').forEach(el => { el.hidden = intent !== 'local'; });
      let shown = 0;
      root.querySelectorAll('[data-product-card]').forEach(el => { const allowed = intent === 'local' || !el.hasAttribute('data-local-only'); el.hidden = !allowed || shown >= 8; if (allowed && shown < 8) shown++; });
      if (current) search(current);
    }
    function showStatus(message) { wrap.hidden = false; status.textContent = message; }
    function card(p) {
      const link = document.createElement('a');
      link.className = 'gg-result'; link.href = p.url;
      if (p.image) {
        const image = document.createElement('img'); image.src = p.image; image.alt = p.title;
        image.loading = 'lazy'; image.width = 500; image.height = 400; link.append(image);
      }
      const title = document.createElement('h3'); title.textContent = p.title;
      const price = document.createElement('p'); price.textContent = p.price;
      const state = document.createElement('p');
      state.textContent = localOnly(p) ? text.local_only : (p.available ? text.available : text.sold_out);
      link.append(title, price, state); return link;
    }
    function helpRoutes(query) {
      const routes = [];
      if (/\b(repair|service(?!\s+(?:course|kit))|tune[ -]?up|fix|broken|not working|diagnostic)\b/i.test(query)) routes.push(['repair', /\b(e-?bike|electric|scooter)\b/i.test(query) ? '/pages/e-mobility-repair' : '/collections/service-and-repair']);
      if (/\b(hours|open|closed|visit|address|location|directions|phone|contact)\b/i.test(query)) routes.push(['visit', '#gg-visit']);
      if (/\b(shipping|delivery|ship|pickup|pick[ -]?up)\b/i.test(query)) routes.push(['shipping', '/policies/shipping-policy']);
      if (/\b(return|returns|refund|refunds)\b/i.test(query)) routes.push(['returns', '/pages/return-policy']);
      if (/\b(community|group ride|ride schedule|wednesday|adventure squad)\b/i.test(query)) routes.push(['ride', '/pages/wednesday-night-ride']);
      if (/\b(compatibility|compatible|will it fit|will this fit|what size|sizing|bike fit)\b/i.test(query)) routes.push(['fit', '/pages/contact-form']);
      return routes;
    }
    function helpCard(route) {
      const link = document.createElement('a'); link.className = 'gg-help-result'; link.href = route[1];
      const title = document.createElement('h3'); title.textContent = text['help_' + route[0] + '_title'];
      const copy = document.createElement('p'); copy.textContent = text['help_' + route[0] + '_copy'];
      link.append(title, copy); return link;
    }
    async function search(query, append = false) {
      current = query.trim(); input.value = current;
      if (!current) return;
      if (!append) { page = 1; results.replaceChildren(); }
      controller?.abort(); controller = new AbortController();
      const request = ++generation;
      more.hidden = true; more.disabled = true; showStatus(text.loading); results.setAttribute('aria-busy', 'true');
      if (/\b(smoking|burning|swollen|overheating)\b.*\bbattery\b|\bbattery\b.*\b(smoke|smoking|fire|burning|swollen|overheating)\b/i.test(current)) {
        status.textContent = text.urgent_copy; more.disabled = false; results.removeAttribute('aria-busy'); return;
      }
      const routes = helpRoutes(current);
      const mixedShopping = routes.length && /\b(parts|tires|pedals|wheels|chain|chains|helmet|helmets|computer|computers)\b/i.test(current);
      if (routes.length) {
        if (!append) routes.forEach(route => results.append(helpCard(route))); status.textContent = text.help_status;
        if (!mixedShopping) { more.disabled = false; results.removeAttribute('aria-busy'); return; }
      }
      const catalogQuery = mixedShopping ? current.replace(/\b(repair|service|tune[ -]?up|fix|broken|diagnostic|and|or|help|need|with|for)\b/gi, ' ').trim() : current;
      const terms = /^(giant|tern)$/i.test(current) ? `vendor:${current}` : (/^Giant OR Tern$/i.test(current) ? 'vendor:Giant OR vendor:Tern' : catalogQuery);
      const url = new URL(root.dataset.searchUrl, window.location.origin);
      url.searchParams.set('q', terms); url.searchParams.set('type', 'product');
      url.searchParams.set('view', 'gg-finder'); url.searchParams.set('page', page);
      url.searchParams.set('options[prefix]', 'last');
      try {
        const response = await fetch(url, {signal: controller.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('search');
        const data = await response.json();
        if (request !== generation) return;
        const products = data.products.filter(p => !isService(p) && (intent === 'local' || !localOnly(p)));
        products.forEach(p => results.append(card(p)));
        status.textContent = results.children.length ? text.status + ' · ' + results.children.length : (intent === 'ship' && (data.products.some(localOnly) || /\b(giant|tern)\b/i.test(current)) ? text.local_warning : text.empty);
        more.hidden = !data.next;
      } catch (e) {
        if (e.name !== 'AbortError' && request === generation) status.textContent = text.error;
      } finally { if (request === generation) { results.removeAttribute('aria-busy'); more.disabled = false; } }
    }
    const carousel = document.querySelector?.('[data-section-type="slideshow-section"]');
    if (carousel && !carousel.dataset.ggAccessible) {
      carousel.dataset.ggAccessible = 'true';
      const pause = carousel.querySelector('.slideshow__pause'), carouselMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function syncCarousel() {
        const dots = carousel.querySelectorAll('.flickity-page-dots .dot');
        dots.forEach((dot, i) => { dot.setAttribute('role', 'button'); dot.tabIndex = 0; dot.setAttribute('aria-label', text.slide_label + ' ' + (i + 1)); });
        const slides = carousel.querySelectorAll('.slideshow__slide'), selected = carousel.querySelector('.slideshow__slide.is-selected') || slides[0];
        slides.forEach(slide => slide.querySelectorAll('.hero__link a').forEach(a => { a.tabIndex = slide === selected ? 0 : -1; }));
        if (dots.length && carouselMotion.matches && pause && !pause.classList.contains('is-paused')) pause.click();
      }
      carousel.addEventListener('keydown', e => {
        if (e.target.matches('.flickity-page-dots .dot') && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); e.target.click(); }
      });
      new MutationObserver(syncCarousel).observe(carousel, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
      carouselMotion.addEventListener('change', syncCarousel); syncCarousel();
    }
    const marquee = root.querySelector('[data-marquee]'), brandPause = root.querySelector('[data-brand-pause]');
    if (marquee && brandPause) {
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      function applyMotion() { marquee.dataset.marqueeReady = String(!motion.matches); brandPause.hidden = motion.matches; }
      brandPause.addEventListener('click', () => {
        const paused = marquee.dataset.paused !== 'true'; marquee.dataset.paused = String(paused);
        brandPause.textContent = paused ? text.resume_brands : text.pause_brands;
      });
      motion.addEventListener('change', applyMotion); applyMotion();
    }
    form.addEventListener('submit', e => { e.preventDefault(); search(input.value); });
    root.querySelectorAll('.gg-intents input').forEach(r => r.addEventListener('change', () => setIntent(r.value)));
    root.querySelectorAll('[data-query]').forEach(b => b.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button != null && e.button !== 0)) return;
      e.preventDefault(); search(b.dataset.query); root.querySelector('.gg-guide').scrollIntoView({block:'start'}); input.focus({preventScroll:true});
    }));
    root.querySelectorAll('[data-local-query]').forEach(b => b.addEventListener('click', () => {
      search(b.dataset.localQuery);
      root.querySelector('.gg-guide').scrollIntoView({block:'start'}); input.focus({preventScroll:true});
    }));
    root.querySelector('[data-reset]').addEventListener('click', () => {
      ++generation; controller?.abort(); current = ''; page = 1; input.value = '';
      results.replaceChildren(); wrap.hidden = true; more.hidden = true; more.disabled = false; results.removeAttribute('aria-busy'); input.focus();
    });
    more.addEventListener('click', () => { page += 1; search(current, true); });
    setIntent(intent);
  }
  document.querySelectorAll('.gg-home').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.gg-home').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
